
<a @click="onDocument" class="w-100" >
    <div class="w-100 pt-2">
        <div style="text-align: center">
            <v-icon
                class="document-icon primary--text mt-1"
            >
                {{ icon }}
            </v-icon>
        </div>
        <div class="black--text mt-0"
             style="max-height: 55px; height: 55px; text-align: center; font-size: 13px; overflow: hidden; display: block">
            <div >
                {{ document.typename }}
            </div>
            <div style="margin-top: -5px;">
                {{ document.subject }}
            </div>
            <div style="margin-top: -3px" class="doc-info">
                {{ document.name }}
            </div>
        </div>
    </div>
</a>
